<script setup lang="ts">
import {
  FOR_LAYWERS_PAGE_TITLE,
  FOR_LAYWERS_PAGE_DESCRIPTION,
} from '@/shared/constants/seoConstants';

import { FOR_LAYWERS_FAQ_QUESTIONS } from '@/shared/constants/faqConstants';
import { ROOT_URL_HOST } from '@/shared/constants/contactConstants';
import SchemaOrg from '@/shared/ui/SchemaOrg/index';

import MainSection from '@/pages/forLaywers/ui/MainSection.vue';
import PopularitySection from '@/pages/forLaywers/ui/PopularitySection/index.vue';
import SuitableSection from '@/pages/forLaywers/ui/SuitableSection.vue';
import OpportunitiesSection from '@/pages/forLaywers/ui/OpportunitiesSection.vue';
import FaqSection from '@/widgets/FaqSection/index';
import SignupSection from '@/pages/forLaywers/ui/SignupSection.vue';
import {
  breadcrumbData,
  webPageData,
  faqData,
} from '@/pages/forLaywers/lib/schemaConstants';

const route = useRoute();
const url = computed(() => `${ROOT_URL_HOST}${route.path}`);

useSeoMeta({
  title: FOR_LAYWERS_PAGE_TITLE,
  description: FOR_LAYWERS_PAGE_DESCRIPTION,
  ogTitle: FOR_LAYWERS_PAGE_TITLE,
  ogDescription: FOR_LAYWERS_PAGE_DESCRIPTION,
  ogSiteName: FOR_LAYWERS_PAGE_TITLE,
  ogType: 'website',
  ogUrl: url,
  ogLocale: 'ru',
  ogImage: `${ROOT_URL_HOST}/og-image.png`,
});

useHead({
  meta: [{ property: 'vk:image', content: `${ROOT_URL_HOST}/og-image.png` }],
  link: [
    {
      rel: 'preload',
      as: 'image',
      href: '/images/lawyers-page/lawyers-main-bg.webp',
      fetchpriority: 'high',
    },
  ],
});
</script>

<template>
  <div class="for-lawyers-page">
    <SchemaOrg type="BreadcrumbList" :data="breadcrumbData" />
    <SchemaOrg type="WebPage" :data="webPageData" />
    <SchemaOrg type="FAQPage" :data="faqData" />
    <MainSection />
    <PopularitySection />
    <SuitableSection />
    <OpportunitiesSection />
    <FaqSection :questions="FOR_LAYWERS_FAQ_QUESTIONS" />
    <SignupSection />
  </div>
</template>
